export default __webpack_public_path__ + "static/logo-circle-0173744575f975513543aa24e934b560.svg";